export default "__VITE_ASSET__CkkVVRBx__"